import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderSlot as _renderSlot, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onSubmit"]
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = {
  class: "btn btn-mod btn-small ms-1",
  type: "submit",
  title: "Start Search"
}

import { truncate } from '@/js/utils'
import useNOIRLabArchives from '@/js/composables/useNOIRLabArchives'
import { nextTick, ref, watch } from 'vue'
import WithLoadingPromise from '@/js/components/loading/WithLoadingPromise.vue'
import Pagination from '@/js/components/Pagination.vue'
import { getNOIRLabNews } from '@/js/api'
import usePageNumberAndQuery from '@/js/composables/usePageNumberAndQuery'


export default /*#__PURE__*/_defineComponent({
  __name: 'NewsList',
  props: {
  programName: String,
  newsFeedUrl: String,
},
  setup(__props) {

const props = __props;



const element = ref<HTMLElement | undefined>()
const withLoadingPromise = ref<InstanceType<typeof WithLoadingPromise>>()
const news = ref<Array<any>>([])

const totalPages = ref<number>(1)
const loadingPage = ref<boolean>(false)
const { page, query } = usePageNumberAndQuery()
const { getMainNewsImage, formatDate, getNewsURLById } = useNOIRLabArchives()

async function loadNews() {
  const params = query.value ? { search: query.value } : null
  const { data } = await getNOIRLabNews(page.value, { params }, props?.newsFeedUrl)
  news.value = data.results
  totalPages.value = data.total_pages
}

async function pageUpdated() {
  loadingPage.value = true
  await reloadNews()
  if (element.value) {
    element.value.scrollIntoView()
  }
  loadingPage.value = false
}

function onSearch() {
  page.value = 1
  reloadNews()
}

function reloadNews() {
  if (withLoadingPromise.value) {
    return withLoadingPromise.value.reload()
  }
  return Promise.resolve()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _mergeProps({
    ref_key: "element",
    ref: element
  }, _ctx.$attrs), [
    _createElementVNode("form", {
      class: "form d-flex justify-content-between align-items-stretch mb-50",
      onSubmit: _withModifiers(onSearch, ["prevent"])
    }, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(query) ? (query).value = $event : null)),
        type: "text",
        class: "form-control search-field round w-full",
        placeholder: `${_ctx.window.gettext('Search')}...`
      }, null, 8 /* PROPS */, _hoisted_2), [
        [_vModelText, _unref(query)]
      ]),
      _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.window.gettext('Search')), 1 /* TEXT */)
    ], 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_1),
    _createVNode(WithLoadingPromise, {
      ref_key: "withLoadingPromise",
      ref: withLoadingPromise,
      "show-loading": !loadingPage.value,
      "async-function": loadNews
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {
          news: news.value,
          getMainNewsImage: _unref(getMainNewsImage),
          formatDate: _unref(formatDate),
          truncate: _unref(truncate)
        }),
        _createVNode(Pagination, {
          modelValue: _unref(page),
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
            pageUpdated
          ],
          "total-pages": totalPages.value,
          loading: loadingPage.value
        }, null, 8 /* PROPS */, ["modelValue", "total-pages", "loading"])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["show-loading"])
  ], 16 /* FULL_PROPS */))
}
}

})